import * as React from 'react'
import { format } from 'date-fns'
import { Calendar as CalendarIcon } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover'

export interface DatePickerProps {
	date?: Date
	onDateChange?: (date: Date | undefined) => void
	placeholder?: string
	disabled?: boolean
	minDate?: Date
	maxDate?: Date
	className?: string
	required?: boolean
}

export function DatePicker({
	date,
	onDateChange,
	placeholder = 'Pick a date',
	disabled = false,
	minDate,
	maxDate,
	className,
}: DatePickerProps) {
	const [open, setOpen] = React.useState(false)

	const handleSelect = (selectedDate: Date | undefined) => {
		onDateChange?.(selectedDate)
		setOpen(false)
	}

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					disabled={disabled}
					className={cn(
						'w-full justify-start text-left font-normal',
						!date && 'text-muted-foreground',
						className
					)}
				>
					<CalendarIcon className="mr-2 h-4 w-4" />
					{date ? format(date, 'PPP') : <span>{placeholder}</span>}
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-auto p-0" align="start">
				<Calendar
					mode="single"
					selected={date}
					onSelect={handleSelect}
					disabled={(date) => {
						if (minDate && date < minDate) return true
						if (maxDate && date > maxDate) return true
						return false
					}}
				/>
			</PopoverContent>
		</Popover>
	)
}

